module.exports = __webpack_public_path__ + "static/media/user-edit.789aa38b.svg";